export const parentNode = (e) => e && e.parentNode && e.parentNode.tagName !== 'BODY' && e.parentNode;
export const parentNodes = (e) => (parentNode(e) ? [e].concat(parentNodes(parentNode(e))) : [e]);
